/* eslint-disable no-param-reassign */
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('accordion-group')
class AccordionGroup extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    this.setupInputs();
    this.selectedInputId = Array.from(this.inputs).find(
      (input) => input.checked,
    )?.id;
    window.addEventListener('swatch:change', this.handleSwatchChange);
  }

  handleSwatchChange = (e) => {
    const isAvailable = e.detail.product.available;
    this.cleanupInputs();
    this.setupInputs(isAvailable);
  };

  setupInputs = (isAvailable = true) => {
    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleInputChange);

      if (this.selectedInputId) {
        input.checked = input.id === this.selectedInputId && isAvailable;
      }
    });
  };

  cleanupInputs = () => {
    this.inputs.forEach((input) => {
      input.removeEventListener('change', this.handleInputChange);
    });
  };

  handleInputChange = (e) => {
    const input = e.target;

    if (input.checked) {
      this.selectedInputId = input.id;

      this.inputs.forEach((i) => {
        if (i !== input) {
          i.checked = false;
        }
      });
    }
  };

  disconnectedCallback() {
    super.disconnectedCallback();
    this.cleanupInputs();
  }

  render() {
    return html` <slot></slot> `;
  }
}

export default AccordionGroup;
